import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";

const PlanningTable = ({ data }) => {
    const [summary, setSummary] = useState({});
    const [tableHeaders, setTableHeaders] = useState([]);
    const [tableRows, setTableRows] = useState([]);
    const [totalRow, setTotalRow] = useState([]);
    const [cartonRow, setCartonRow] = useState([]);
    const [cartonTotal, setCartonTotal] = useState(0);
    const [selectedRows, setSelectedRows] = useState([]);
  useEffect(() => {
        if (data && data.success) {
            setCartonTotal(0);
            const summaryData = summarizeProductsByCompany(data.success);
            setSummary(summaryData);

            const headers = generateTableHeaders(summaryData);
            setTableHeaders(headers);

            const rows = generateTableRows(summaryData, headers);
            setTableRows(rows);
            setSelectedRows(rows.map((_, index) => index));

            const totals = calculateTotals(summaryData, headers);
            setTotalRow(totals);

            const cartons = calculateCartonRow(summaryData, headers, data);
            setCartonRow(cartons);
        }
    }, [data]);


    useEffect(() => {
    if (tableRows.length > 0 && tableHeaders.length > 0 && Object.keys(summary).length > 0) {
        const totals = calculateTotals(summary, tableHeaders, selectedRows, tableRows);
        setTotalRow(totals);

        const cartons = calculateCartonRow(summary, tableHeaders, data, selectedRows, tableRows);
        setCartonRow(cartons);
    }
}, [selectedRows, summary, tableHeaders, tableRows, data]);

    // Function to process and summarize the products by company title
    const summarizeProductsByCompany = (data) => {
        const summary = {};
        if (Array.isArray(data)) {
            data.forEach((item) => {
                const { product, model } = item;
                model.forEach((singleModel) => {
                    const title = singleModel.societe.title;
                    const quantity = singleModel.quantity;

                    if (!summary[title]) {
                        summary[title] = [];
                    }

                    const existingProduct = summary[title].find(
                        (p) => p.productCode === product.productCode
                    );
                    if (existingProduct) {
                        existingProduct.quantity += quantity;
                    } else {
                        if (product.description != null) {
                            summary[title].push({
                                productName: product.description,
                                productCode: product.productCode,
                                quantity: quantity,
                                creationDate: new Date(product.creation_date),
                            });
                        } else {
                            summary[title].push({
                                productName: product.name,
                                productCode: product.productCode,
                                quantity: quantity,
                                creationDate: new Date(product.creation_date),
                            });
                        }
                    }
                });
            });
        }
        return summary;
    };

    const generateTableHeaders = (summary) => {
        let headers = [];
        let exist = false;
        let otherHeaders = [{ productName: "", creationDate: new Date("2023-01-01T00:00:00") }, { productName: "MAGASIN", creationDate: new Date("2024-01-01T00:00:00") }];

        Object.keys(summary).forEach((societe) => {
            summary[societe].forEach((product) => {
                try {
                    otherHeaders.forEach((element, index) => {
                        if (element.productName == product.productName) {
                            exist = true;
                            throw "Break";
                        }
                    });
                } catch (e) {
                    if (e !== "Break") throw e;
                }

                if (!exist) {
                    otherHeaders.push({
                        productName: product.productName,
                        creationDate: new Date(product.creationDate),
                    });
                }
                exist = false;
            });
        });

        otherHeaders.sort((a, b) => a.creationDate - b.creationDate);
        otherHeaders.forEach((headerObject) => {
            headers.push(headerObject.productName);
        });

        return headers;
    };

    const generateTableRows = (summary, headers) => {
        const rows = [];
        Object.keys(summary).forEach((societe) => {
            const row = [societe];
            headers.slice(1).forEach((header) => {
                const product = summary[societe].find(
                    (product) => product.productName === header
                );
                row.push(product ? product.quantity : "");
            });
            rows.push(row);
        });
        return rows;
    };

    // const calculateTotals = (summary, headers) => {
    //     const totals = ["Total"];
    //     headers.slice(1).forEach((header) => {
    //         let total = 0;
    //         Object.keys(summary).forEach((societe) => {
    //             const product = summary[societe].find(
    //                 (product) => product.productName === header
    //             );
    //             if (product) {
    //                 total += product.quantity;
    //             }
    //         });
    //         totals.push(total > 0 ? total : "");
    //     });
    //     return totals;
    // };

    const calculateTotals = (summary, headers, selectedRows, tableRows) => {
    const totals = ["Total"];
    headers.slice(1).forEach((header) => {
        let total = 0;
        selectedRows?.forEach((rowIndex) => {
            const societe = tableRows[rowIndex][0];
            const product = summary[societe]?.find(
                (product) => product.productName === header
            );
            if (product) {
                total += product.quantity;
            }
        });
        totals.push(total > 0 ? total : "");
    });
    return totals;
};

    // const calculateCartonRow = (summary, headers, data) => {
    //     const cartonRow = ["Colis"];
    //     let total = 0;
    //     headers.slice(1).forEach((header) => {
    //         let totalCarton = 0;
    //         Object.keys(summary).forEach((societe) => {
    //             const product = summary[societe].find(
    //                 (product) => product.productName === header
    //             );
    //             if (product) {
    //                 const productDetails = data.success.find(
    //                     (item) => item.product.productCode === product.productCode
    //                 )?.product;
    //                 if (productDetails && productDetails.unite > 0) {
    //                     totalCarton += product.quantity / productDetails.unite;
    //                 }
    //             }
    //         });

    //         if (totalCarton > 0) {
    //             total = total + parseFloat(totalCarton.toFixed(2));
    //             setCartonTotal(total?.toFixed(2));
    //         }
    //         cartonRow.push(totalCarton > 0 ? totalCarton.toFixed(2) : "-");
    //     });
    //     return cartonRow;
    // };
const calculateCartonRow = (summary, headers, data, selectedRows, tableRows) => {
    const cartonRow = ["Colis"];
    let total = 0;
    headers.slice(1).forEach((header) => {
        let totalCarton = 0;
        selectedRows?.forEach((rowIndex) => {
            const societe = tableRows[rowIndex][0];
            const product = summary[societe]?.find(
                (product) => product.productName === header
            );
            if (product) {
                const productDetails = data.success.find(
                    (item) => item.product.productCode === product.productCode
                )?.product;
                if (productDetails && productDetails.unite > 0) {
                    totalCarton += product.quantity / productDetails.unite;
                }
            }
        });

        if (totalCarton > 0) {
            total = total + parseFloat(totalCarton.toFixed(2));
        }
        cartonRow.push(totalCarton > 0 ? totalCarton.toFixed(2) : "-");
    });
    setCartonTotal(total?.toFixed(2));
    return cartonRow;
};
  
   const handleRowSelect = (index) => {
    setSelectedRows(prev => {
        const newSelectedRows = prev.includes(index) 
            ? prev.filter(i => i !== index) 
            : [...prev, index];
        return newSelectedRows;
    });
};

const handleSelectAll = (e) => {
    if (e.target.checked) {
        setSelectedRows(tableRows.map((_, index) => index));
    } else {
        setSelectedRows([]);
    }
};
    const chunkColumns = (headers, chunkSize) => {
        const chunks = [];
        for (let i = 2; i < headers.length; i += chunkSize) {
            chunks.push(headers.slice(i, i + chunkSize));
        }
        return chunks;
    };

    const handlePrint = () => {
        const css = `
            @page { size: landscape; }
            table { width: 100%; }
            table, th, td { border: 1px solid black; border-collapse: collapse; }
            th, td { padding: 3px; text-align: center; }
            .table-wrapper { page-break-before: always; }
            .no-print { display: none; }
        `;

        const head = document.head || document.getElementsByTagName("head")[0];
        const style = document.createElement("style");
        style.type = "text/css";
        style.media = "print";
        if (style.styleSheet) {
            style.styleSheet.cssText = css;
        } else {
            style.appendChild(document.createTextNode(css));
        }
        head.appendChild(style);

        const printContents = document.getElementById("planning-table").innerHTML;
        const originalContents = document.body.innerHTML;

        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
    };
    const columnChunks = chunkColumns(tableHeaders, 15);


    return (
        <section className="content my-4">
            <div id="planning-table">
                <div
                    style={{
                        display: "flex",
                        fontFamily: "Arial, sans-serif",
                        fontSize: "10px",
                        justifyContent: "space-between",
                        marginBottom: "5px",
                    }}
                >
                    <div style={{ maxWidth: "30%" }}>
                        <h6 style={{ margin: 0 }}>{data?.societe?.title}</h6>
                        <p style={{ margin: 0 }}>
                            Numéro d'enregistrement :
                            {data?.societe?.matricule} / {data?.societe?.codeCategorie} / {data?.societe?.codeTVA}
                        </p>
                    </div>
                    <div>
                        <p style={{ margin: 0 }}>
                            CHAUFFEUR: {data?.transporteur?.firstName}{" "}
                            {data?.transporteur?.lastName}
                        </p>
                    </div>
                    <div>
                        <p style={{ margin: 0 }}>
                            COMMERCIAL: {data?.commercial?.firstName}{" "}
                            {data?.commercial?.lastName}
                        </p>
                    </div>
                </div>

                {/* <div className="no-print">
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="selectAll"
                            checked={selectedRows.length === tableRows.length && tableRows.length > 0}
                            onChange={handleSelectAll}
                        />
                        <label className="form-check-label" htmlFor="selectAll">
                            {selectedRows.length === tableRows.length && tableRows.length > 0 ?
                                "Désélectionner tout" : "Sélectionner tout"}
                        </label>
                    </div>
                   
                </div> */}

                {columnChunks.map((chunk, index) => (
                    <Table
                        bordered
                         className={`text-center ${index !== 0 ? "table-wrapper" : ""}`}
                        key={index}
                        style={{
                            fontFamily: "Arial, sans-serif",
                            fontSize: "10px",
                        }}
                    >
                        <thead className="thead-light">
                            <tr>
                                <th className="no-print" >{tableHeaders[0]}</th>
                                <th>{tableHeaders[1]}</th>
                                {chunk.map((header, i) => {
                                   return <th key={i}>{header}</th>
                                }
                                   
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {tableRows.map((row, rowIndex) => (
                                <tr
                                    key={rowIndex}
                                    className={!selectedRows.includes(rowIndex) ? "no-print" : ""}
                                >
                                    <td  className="no-print"  style={{ padding: "0" ,textAlign: "center", verticalAlign: "middle"}}>
                                        <input
                                            type="checkbox"
                                            style={{
                                                width: "10px",
                                                height: "10px",
                                                minWidth: "10px", // Ensures the width isn't overridden by other styles
                                                minHeight: "10px", // Ensures the height isn't overridden by other styles
                                                fontFamily: "Arial, sans-serif",
                                                 margin: "0 auto",  // Horizontal centering
                                                fontSize: "10px",
                                                cursor: "pointer", // Optional: changes cursor on hover
                                            }}
                                            className="form-check-input me-1 no-print"
                                            checked={selectedRows.includes(rowIndex)}
                                            onChange={() => handleRowSelect(rowIndex)}
                                        />

                                    </td>
                                    <td style={{ padding: "0" }}>{row[0]}</td>
                                    {chunk.map((header, i) => {
                                        const colIndex = tableHeaders.indexOf(header);
                                        return <td style={{ padding: "0" }} key={i}>{row[colIndex] || ""}</td>;
                                    })}
                                </tr>
                            ))}
                            <tr>
                                <td className="no-print" style={{ padding: "0" }}></td>
                                <td style={{ padding: "0" }}>{totalRow[0]}</td>
                                {chunk.map((header, i) => {
                                    const colIndex = tableHeaders.indexOf(header);
                                    return (
                                        <td style={{ padding: "0" }} key={i}>
                                            <strong>{totalRow[colIndex]}</strong>
                                        </td>
                                    );
                                })}
                            </tr>
                            <tr>
                                <td className="no-print" style={{ padding: "0" }}></td>
                                <td style={{ padding: "0" }}><strong>{cartonRow[0]}</strong></td>
                                {chunk.map((header, i) => {
                                    const colIndex = tableHeaders.indexOf(header);
                                    return (
                                        <td style={{ padding: "0" }} key={i}>
                                            <strong>{cartonRow[colIndex]}</strong>
                                        </td>
                                    );
                                })}
                            </tr>
                        </tbody>
                    </Table>
                ))}
                <div
                    style={{
                        display: "flex",
                        fontFamily: "Arial, sans-serif",
                        fontSize: "10px",
                        justifyContent: "space-between",
                        marginBottom: "5px",
                    }}
                >
                    <h6 style={{ margin: 0 }}>
                        Total des colis: {cartonTotal}
                    </h6>
                </div>
            </div>

            <div className="card-footer no-print">
                <button className="btn btn-dark float-right" onClick={handlePrint}>
                    Imprimer
                </button>
            </div>
        </section>
    );
};

export default PlanningTable;